// export { default as ui } from "./ui";

const files = require.context(".", false, /\.js$/);
const coreFiles = require.context('@core/store/modules/', false, /\.js$/)
const modules = {};

files.keys().forEach((fileName) => {
  if (fileName === "./index.js") return;
  const moduleName = fileName.replace(/(\.\/|\.js)/g, "");
  modules[moduleName] = files(fileName).default;
});

coreFiles.keys().forEach(fileName => {
  if (fileName ==='./index.js')
    return
  
  const moduleName= fileName.replace(/(\.\/|\.js)/g,'')
  modules[moduleName] = require(`@core/store/modules/${moduleName}.js`).default
})
export default modules;
